/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Ready_QInputs */

const en_wc_faq_ready_q = /** @type {(inputs: Wc_Faq_Ready_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it fully replace Microsoft Word today?`)
};

/**
* | output |
* | --- |
* | "Can it fully replace Microsoft Word today?" |
*
* @param {Wc_Faq_Ready_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_ready_q = /** @type {((inputs?: Wc_Faq_Ready_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Ready_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_ready_q(inputs)
});
export { wc_faq_ready_q as "wc.faq.ready.q" }